import React from 'react';
import { useUser } from '../store/UserContext';
import AdminDashboardPage from './AdminDashboardPage';
import TeacherDashboardPage from './TeacherDashboardPage';

export default function DashboardPage() {
  const { user } = useUser();
  if (user?.accessScope === 'staff' || user?.accessScope === 'staff_all') {
    return <TeacherDashboardPage />;
  }
  return <AdminDashboardPage />;
}
